import classNames from 'classnames';
import Link from '@/components/Link';

import styles from './element.module.css';

const Element = ({
  children,
  type = 'folder',
  translatedName,
  isNotLink = false,
  folder,
  href,
}) => {
  const classesForResult = classNames(
    styles.root,
    isNotLink && styles.cardForResult
  );
  const linkToFolder = href ? href : `/templates/${translatedName}`;

  const linkToTemplate =
    !isNotLink &&
    (href ? href : `/templates/${folder.translatedName}/${translatedName}`);

  if (isNotLink)
    return (
      <div className={classesForResult}>
        <div className={styles.iconContainer}>
          <img
            className={styles.icon}
            src="/icons/explorer/file_forma.svg"
            alt=""
          />
        </div>
        <div className={styles.nameContainer}>
          <div className={styles.name}>
            {children}
          </div>
        </div>
      </div>
    );

  if (type === 'folder')
    return (
      <Link className={styles.root} href={linkToFolder}>
        <div className={styles.iconContainer}>
          <img
            className={styles.icon}
            src="/icons/explorer/folder_forma.svg"
            alt=""
          />
        </div>
        <div className={styles.nameContainer}>
          <div className={styles.name}>
            {children}
          </div>
        </div>
      </Link>
    );

  return (
    <Link href={linkToTemplate} className={styles.root}>
      <div className={styles.iconContainer}>
        <img
          className={styles.icon}
          src="/icons/explorer/file_forma.svg"
          alt=""
        />
      </div>
      <div className={styles.nameContainer}>
        <div className={styles.name}>
          {children}
        </div>
      </div>
    </Link>
  );
};

export default Element;
